import React, { useMemo, useState } from "react";
import { useEndpointHook } from "../../../hooks/useEndpointHook";
import { useDispatch, useSelector } from "react-redux";
import { financingRequestsClear } from "../../../redux/reducers/financingRequestsReducer";
import Flx from "../../layout/Flx";
import FileUploadFieldWithModal from "../../common/FileUploadFieldWithModal";
import { grey } from "@mui/material/colors";
import { Box, Button } from "@mui/material";
import BasicFilesTable from "../../tables/BasicFilesTable";
import Txt from "../../typography/Txt";
import { size } from "lodash";
import {
  CheckRounded,
  DoNotDisturb,
  DoNotDisturbOutlined,
} from "@mui/icons-material";

const FinancingRequestTermsSheetTab = ({ dealId, loanDocuments }) => {
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const { loading, uploadFilesToLoan } = useEndpointHook();
  const profile = useSelector((state) => state?.profile);
  const dispatch = useDispatch();

  const termSheetDocs = useMemo(
    () => loanDocuments?.filter((doc) => doc.docType === "Term Sheet"),
    [loanDocuments],
  );
  const handleOnSubmit = (f) => {
    console.log("SUBMITTT", f);

    // return;
    uploadFilesToLoan({
      dealId: dealId,
      files: f,
      onSuccessFn: () => {
        setUploadedFiles(null);
        dispatch(financingRequestsClear());
      },
    });
  };
  return (
    <Flx column g={1.5}>
      <Flx fw jb ac>
        <Flx g={0.2} column sx={{ mb: 2 }}>
          <Txt bold>Review and approve term sheet</Txt>
          <Txt secondary>
            A new term sheet has been uploaded. Please review the terms and
            accept or reject.
          </Txt>
        </Flx>
        <Flx ac g={1}>
          <Button
            startIcon={<DoNotDisturbOutlined className="thin" />}
            color="error"
          >
            Reject Terms
          </Button>
          <Button startIcon={<CheckRounded className="thin" />} color="success">
            Accept Terms
          </Button>
        </Flx>
      </Flx>
      <Box
        sx={{
          maxHeight: "800px",
          overflowY: "auto",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: "8px",
          ".ag-row-last": {
            borderBottom: "none !important",
          },
          ".ag-header-viewport": {
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          },
        }}
      >
        <BasicFilesTable
          headerHeight={50}
          showStatus
          showUploadDate
          files={termSheetDocs}
        />
      </Box>
    </Flx>
  );
};
export default FinancingRequestTermsSheetTab;
